var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-container',[_c('el-header',[_c('bHeader')],1),_c('el-container',[_c('el-aside',{style:({'width':_vm.$store.state.asideWidth+'px'})},[_c('bAside')],1),_c('el-main',[_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }